<template>
  <div class="collapsible-section">
    <!-- Loading overlay when fetching job details -->
    <!-- <div v-if="isLoading" class="loading-overlay">
      <v-progress-circular indeterminate color="primary" size="40"></v-progress-circular>
      <p class="mt-2">Loading job details...</p>
    </div> -->
    
    <div class="header" @click="toggle">
      <div>
        <!-- <strong>Support Preferences</strong> -->
        <!-- <div class="desc">Including specific qualities help support workers know what your needs are</div> -->
      </div>
      <!-- <v-btn icon variant="text" class="chevron-btn">
        <v-icon>{{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn> -->
    </div>

    <v-expand-transition>
      <div v-if="expanded">
        <v-form class="support-preferences-form" @submit.prevent="handleSubmit">
          <div class="support-preferences">
            <AppFormHeader
              v-if="!isOnboarding"
              :title="title"
              :description="description"
              :loading="pending || isDisabled"
              class="mb-5"
              :showButton="true"
              @submit="handleSubmit"
            />

            <!-- <AppFormCard
              title="Profile Visibility"
              subtitle="Please select if you would like your profile to be visible to Support Workers."
              class="mt-4"
              no-gutter
            >
              <v-radio-group
                v-model="form.profile_visibility"
                hide-details="auto"
                :error-messages="errors?.profile_visibility"
                @update:model-value="onVisibilityChange"
              >
                <AppFormRadioItem
                  v-for="(i, k) in visibilityOptions"
                  :key="k"
                  :description="i.description"
                  :value="i.value"
                  :disabled="pending"
                  class="card-option-item pa-2 mt-4"
                  no-gutter
                />
              </v-radio-group>
            </AppFormCard> -->

            <AppFormCard
              title="Support Worker Gender *"
              :class="['mt-4', { 'error-card': errors?.gender }]"
              no-gutter
            >
              <template v-for="(gender, n) in genderOptions" :key="n">
                <v-checkbox
                  v-model="form.gender"
                  :value="gender.value"
                  :label="gender.description"
                  :disabled="pending"
                  :multiple="true"
                  hide-details
                  density="compact"
                  :color="errors?.gender ? 'error' : 'primary'"
                  :class="['mt-2', { 'error-checkbox': errors?.gender }]"
                  @update:model-value="(value) => handleGenderChange(gender.value, value)"
                ></v-checkbox>
              </template>
            </AppFormCard>
            <div v-if="errors?.gender" class="error-message">
              {{ errors?.gender }}
            </div>
             

            <!-- <AppFormCard
              title="Days & Time"
              subtitle="May include things like LGBTQIA+ friendly, knows Auslan, Autism experience, Cerebral Palsy experience, etc."
              class="mt-4"
              no-gutter
            >
              <AppMultiTagSearch
                v-model="selectedAttributes"
                :items="professionalAttributeItems"
                :disabled="pending"
                item-value="id"
                item-title="name"
                return-object
                hide-details="auto"
                placeholder="Enter what's important"
                class="pt-4"
                @search="debouncedSearchAttributes($event)"
                @remove="removeSelectedAttribute"
              />
            </AppFormCard>

            <AppFormCard
              title="Restrictions (optional)"
              subtitle="May include No smokers or No pets etc"
              class="mt-4"
              no-gutter
            >
              <AppMultiTagSearch
                v-model="selectedRestrictions"
                :items="restrictionItems"
                :disabled="pending"
                item-value="id"
                item-title="name"
                return-object
                hide-details="auto"
                placeholder="Enter restrictions"
                class="pt-4"
                @search="debouncedSearchRestrictions($event)"
                @remove="removeSelectedRestriction"
              />
            </AppFormCard> -->

            <AppFormCard
            title="Is this an ongoing job?"
            :class="['mt-4', { 'error-card': errors?.isOngoingJob }]"
            no-gutter
            >
              <AppTypography type="headline-1" class="text-left pb-2">Days & Time</AppTypography>
              <v-radio-group v-model="form.isOngoingJob" hide-details="auto">
                <AppFormRadioItem
                  v-for="(option, k) in ongoingJobOptions"
                  :key="k"
                  :description="option.description"
                  :value="option.value"
                  :disabled="pending"
                  :class="['card-option-item ongoing-job-radio pa-2']"
                  no-gutter
                />
              </v-radio-group>
            </AppFormCard>

            <!-- Dynamic form based on ongoing job selection -->
            <AppFormCard
              v-if="form.isOngoingJob === 'yes'"
              title="Schedule Details"
              subtitle=""
              :class="['mt-4']"
              no-gutter
            >
              <div class="schedule-section">
                <!-- Days and Times Selection -->
                <div class="mb-4">
                  <AppTypography type="subheadline-1" class="mb-2 mt-2">Select Days and Times</AppTypography>
                  <div v-for="(day, index) in weekDays" :key="index" class="day-schedule mb-3">
                    <v-checkbox
                      v-model="form.selectedDays"
                      :value="day.value"
                      :label="day.label"
                      :disabled="pending"
                      hide-details
                      density="compact"
                      color="primary"
                      class="mb-2"
                    />
                    <div v-if="(form.selectedDays || []).includes(day.value) && day.value !== 'toBeAdvisedDaysTimes'" class="time-selection ml-8">
                      <v-row no-gutters>
                        <v-col cols="6" class="pr-2">
                          <AppTimePicker
                            :model-value="getDaySchedule(day.value, 'startTime')"
                            @update:model-value="(value) => updateDaySchedule(day.value, 'startTime', value)"
                            label="Start Time (optional)"
                            :disabled="pending"
                          />
                        </v-col>
                        <v-col cols="6" class="pl-2">
                          <AppTimePicker
                            :model-value="getDaySchedule(day.value, 'endTime')"
                            @update:model-value="(value) => updateDaySchedule(day.value, 'endTime', value)"
                            label="End Time (optional)"
                            :disabled="pending"
                          />
                        </v-col>
                      </v-row>
                    </div>
                  </div>
                </div>

                <!-- I don't know yet option -->
                  <!--<div class="mt-4">
                  <v-checkbox
                    v-model="form.scheduleUnknown"
                    :label="'I don\'t know yet'"
                    :disabled="pending"
                    hide-details
                    density="compact"
                    color="primary"
                    @update:model-value="onScheduleUnknownChange"
                  />
                </div>-->
              </div>
            </AppFormCard>

            <AppFormCard
              v-if="form.isOngoingJob === 'no'"
              title="Date Range"
              subtitle="Please specify the start and end dates for this job"
              :class="['mt-4', { 'error-card': errors?.startDate || errors?.endDate }]"
              no-gutter
            >
              <v-row no-gutters>
                <v-col cols="12" md="6" class="pr-md-2">
                  <AppDatePicker
                    v-model="form.startDate"
                    label="Start Date"
                    :disabled="pending"
                    :error-messages="errors?.startDate"
                    :allow-typing="false"
                    :allow-selecting-dates="true"
                    placeholder="DD/MM/YYYY"
                  />
                </v-col>
                <v-col cols="12" md="6" class="pl-md-2 mt-4 mt-md-0">
                  <AppDatePicker
                    v-model="form.endDate"
                    label="End Date"
                    :disabled="pending"
                    :error-messages="errors?.endDate"
                    :allow-typing="false"
                    :allow-selecting-dates="true"
                    placeholder="DD/MM/YYYY"
                  />
                </v-col>
              </v-row>
            </AppFormCard>
            <div v-if="errors?.isOngoingJob" class="error-message">
              {{ errors?.isOngoingJob }}
            </div>

            <AppFormCard
              title="Support Worker Age *"
              :class="['mt-4', { 'error-card': errors?.age }]"
              no-gutter
            >
              <template v-for="(age, n) in ageOptions" :key="n">
                <v-checkbox
                  v-model="form.age"
                  :value="age.value"
                  :label="age.description"
                  :disabled="pending"
                  :multiple="true"
                  hide-details
                  density="compact"
                  :color="errors?.age ? 'error' : 'primary'"
                  :class="['mt-2', { 'error-checkbox': errors?.age }]"
                  @update:model-value="(value) => handleAgeChange(age.value, value)"
                ></v-checkbox>
              </template>
            </AppFormCard>
            <div v-if="errors?.age" class="error-message">
              {{ errors?.age }}
            </div>
          </div>
        </v-form>
      </div>
    </v-expand-transition>
  </div>
</template>

<script setup lang="ts">
import { carOwnershipOptions, genderOptions, visibilityOptionPrivate, ageOptions } from '@/content/preferences';
import { AppErrorMessages, AppFormCard, AppFormHeader, AppFormRadioItem, AppMultiTagSearch, AppDatePicker, AppTimePicker, AppTypography } from '@/components/base';
import type { SupportPreferenceForm } from '@/types/SupportPreference';
import { useAuthStore } from '@/modules/auth/store/auth';
import attributeService from '@/services/AttributeService';
import restrictionService from '@/services/RestrictionService';
import type { Attribute as IAttribute } from '@/types/Attribute';
import type { Restriction as IRestriction } from '@/types/Restriction';
import { debounce } from 'lodash';
import { computed, nextTick, onMounted, ref, watch } from 'vue';

const props = withDefaults(
  defineProps<{
    title?: string;
    description?: string;
    isOnboarding?: boolean;
    jobDetails?: any;
  }>(),
  {
    title: 'Support Preferences',
    description: '',
    isOnboarding: true,
    jobDetails: null,
  }
);

const emits = defineEmits<{
  (e: 'success'): void;
  (e: 'next', value: string): void;
  (e: 'skip'): void;
  (e: 'update:userDetails', value: any): void;
}>();


const expanded = ref(true);
function toggle() {
  expanded.value = !expanded.value;
  console.log('Expanded:', expanded.value);
}

// --- Form setup ---
const {
  v$,
  form,
  handleSubmit: onSubmit,
  getErrors,
} = useForm<SupportPreferenceForm>({
  form: {
    profile_visibility: '',
    gender: [] as string[], // Fix type annotation
    catered_professional_attributes: [],
    ndis_registered: '',
    restrictions: [],
    car_ownership: '',
    isOngoingJob: '',
    selectedDays: [],
    daySchedules: {
      monday: { startTime: '', endTime: '' },
      tuesday: { startTime: '', endTime: '' },
      wednesday: { startTime: '', endTime: '' },
      thursday: { startTime: '', endTime: '' },
      friday: { startTime: '', endTime: '' },
      saturday: { startTime: '', endTime: '' },
      sunday: { startTime: '', endTime: '' },
    },
    scheduleUnknown: false,
    startDate: '',
    endDate: '',
    age: [] as string[], // Fix type annotation - make it an array
  },
  rules: {
    // profile_visibility: {
    //   required: useValidation().VALIDATIONS.required('Visibility'),
    // },
    gender: {
      required: useValidation().VALIDATIONS.required('Gender preference'),
    },
    // car_ownership: {
    //   required: useValidation().VALIDATIONS.required('Car Ownership'),
    // },
    isOngoingJob: {
      required: useValidation().VALIDATIONS.required('Job type'),
    },
    age: {
      required: useValidation().VALIDATIONS.required('Age'),
    },
  },
});

const { user } = useAuthStore();
const selectedAttributes = ref<IAttribute[]>([]);
const professionalAttributeItems = ref<IAttribute[]>([]);
const selectedRestrictions = ref<IRestriction[]>([]);
const restrictionItems = ref<IRestriction[]>([]);
const { data, error: serverError, execute: execSubmit, pending } = useSubmit();
const { showSnackbar } = useSnackbar();

// New data for Days & Time functionality
const ongoingJobOptions = [
  {
    description: 'Yes, this is an ongoing job',
    value: 'yes',
  },
  {
    description: 'No, this is a one-time job',
    value: 'no',
  },
];

const weekDays = [
  { label: 'Monday', value: 'monday' },
  { label: 'Tuesday', value: 'tuesday' },
  { label: 'Wednesday', value: 'wednesday' },
  { label: 'Thursday', value: 'thursday' },
  { label: 'Friday', value: 'friday' },
  { label: 'Saturday', value: 'saturday' },
  { label: 'Sunday', value: 'sunday' },
  { label: 'Days and Times to be Advised', value: 'toBeAdvisedDaysTimes' },
];

// Helper function to get day number (1-7) from day name
function getDayNumber(dayName: string): number {
  const dayMap: { [key: string]: number } = {
    'monday': 1,
    'tuesday': 2,
    'wednesday': 3,
    'thursday': 4,
    'friday': 5,
    'saturday': 6,
    'sunday': 7,
    'toBeAdvisedDaysTimes': 8,
  };
  return dayMap[dayName] || 0;
}

const errors = computed(() => getErrors(serverError.value?.data?.errors));
const isDisabled = computed(() => {
  return v$.value.$invalid || pending.value;
});

async function initialize(): Promise<void> {
  const preference = user?.support_preference;

  // Handle catered_professional_attributes which can be numbers or objects
  const professionalAttributes = preference?.catered_professional_attributes || [];
  selectedAttributes.value = Array.isArray(professionalAttributes) && professionalAttributes.length > 0 && typeof professionalAttributes[0] === 'object' 
    ? professionalAttributes as IAttribute[] 
    : [];

  // Handle restrictions which can be numbers or objects
  const restrictions = preference?.restrictions || [];
  selectedRestrictions.value = Array.isArray(restrictions) && restrictions.length > 0 && typeof restrictions[0] === 'object' 
    ? restrictions as IRestriction[] 
    : [];

  // Also populate direct user fields if they exist
  if (preference) {
    user.support_worker_gender = preference.gender;
    user.is_ongoing_job = preference.isOngoingJob;
    user.selected_days = preference.selectedDays;
    user.day_schedules = preference.daySchedules;
    user.schedule_unknown = preference.scheduleUnknown;
    user.job_start_date = preference.startDate;
    user.job_end_date = preference.endDate;
    user.support_worker_age = preference.age;
  }

  form.value = {
    profile_visibility: preference?.profile_visibility || '',
    gender: preference?.gender ? 
      (Array.isArray(preference.gender) ? preference.gender : [preference.gender]) : 
      [],
    catered_professional_attributes: selectedAttributes.value.map((i: IAttribute) => i.id),
    ndis_registered: preference?.ndis_registered || '',
    restrictions: selectedRestrictions.value.map((i: IRestriction) => i.id),
    car_ownership: preference?.car_ownership || '',
    isOngoingJob: preference?.isOngoingJob || '',
    selectedDays: preference?.selectedDays || [],
    daySchedules: preference?.daySchedules || {
      monday: { startTime: '', endTime: '' },
      tuesday: { startTime: '', endTime: '' },
      wednesday: { startTime: '', endTime: '' },
      thursday: { startTime: '', endTime: '' },
      friday: { startTime: '', endTime: '' },
      saturday: { startTime: '', endTime: '' },
      sunday: { startTime: '', endTime: '' },
    },
    scheduleUnknown: preference?.scheduleUnknown || false,
    startDate: preference?.startDate || '',
    endDate: preference?.endDate || '',
    age: preference?.age ? 
      (Array.isArray(preference.age) ? preference.age : [preference.age]) : 
      [],
  };

  v$.value.$reset();
  
  // Emit initial userDetails to parent
  const userDetails = {
    gender: form.value.gender,
    is_ongoing_job: form.value.isOngoingJob,
    days_time: form.value.isOngoingJob === 'yes' ? 
    (form.value.scheduleUnknown ? 'I don\'t know yet' : 
    form.value.selectedDays?.map((day: string) => ({
      [getDayNumber(day)]: 1,
      start_time: (form.value.daySchedules as any)[day]?.startTime || '',
      end_time: (form.value.daySchedules as any)[day]?.endTime || ''
    })) || []) :
    {
      start_date: formatDateToDDMMYYYY(form.value.startDate),
      end_date: formatDateToDDMMYYYY(form.value.endDate)
    },
    support_worker_age_range: form.value.age,
  };
  emits('update:userDetails', userDetails);
}

const debouncedSearchAttributes = debounce(async (search = '') => {
  const { data } = await attributeService.getAttributes(search);
  professionalAttributeItems.value = data.value || [];
}, 400);

const debouncedSearchRestrictions = debounce(async (search = '') => {
  const { data } = await restrictionService.getRestrictions(search);
  restrictionItems.value = data.value || [];
}, 400);

function removeSelectedAttribute(attr: IAttribute) {
  selectedAttributes.value = selectedAttributes.value.filter((a: IAttribute) => a.id !== attr.id);
}

function removeSelectedRestriction(attr: IRestriction) {
  selectedRestrictions.value = selectedRestrictions.value.filter((a: IRestriction) => a.id !== attr.id);
}

function onVisibilityChange() {
  if (form.value.profile_visibility === visibilityOptionPrivate) {
    showSnackbar({
      text: 'Private profiles can only be seen by workers you contact directly.',
      state: true,
    });
  }
}

function skip() {
  emits('next', 'privacy-policy');
}

function onScheduleUnknownChange(value: boolean | null) {
  if (value) {
    // Clear selected days and schedules when "I don't know yet" is checked
    form.value.selectedDays = [];
    form.value.daySchedules = {
      monday: { startTime: '', endTime: '' },
      tuesday: { startTime: '', endTime: '' },
      wednesday: { startTime: '', endTime: '' },
      thursday: { startTime: '', endTime: '' },
      friday: { startTime: '', endTime: '' },
      saturday: { startTime: '', endTime: '' },
      sunday: { startTime: '', endTime: '' },
    };
  }
}

function getDaySchedule(day: string, field: 'startTime' | 'endTime'): string {
  return (form.value.daySchedules as any)?.[day]?.[field] || '';
}

function updateDaySchedule(day: string, field: 'startTime' | 'endTime', value: string) {
  if (!form.value.daySchedules) {
    form.value.daySchedules = {
      monday: { startTime: '', endTime: '' },
      tuesday: { startTime: '', endTime: '' },
      wednesday: { startTime: '', endTime: '' },
      thursday: { startTime: '', endTime: '' },
      friday: { startTime: '', endTime: '' },
      saturday: { startTime: '', endTime: '' },
      sunday: { startTime: '', endTime: '' },
    };
  }
  (form.value.daySchedules as any)[day][field] = value;
}

// Helper function to format date to DD/MM/YYYY
const formatDateToDDMMYYYY = (dateString: string): string => {
  if (!dateString) return '';
  
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return '';
    
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    
    return `${day}/${month}/${year}`;
  } catch (error) {
    console.error('Error formatting date:', error);
    return '';
  }
};

// Helper function to parse date from DD/MM/YYYY format
const parseDate = (dateString: string): string => {
  if (!dateString) return '';
  
  // If it's already in DD/MM/YYYY format, convert to YYYY-MM-DD for the form
  if (dateString.includes('/')) {
    const parts = dateString.split('/');
    if (parts.length === 3) {
      const day = parts[0];
      const month = parts[1];
      const year = parts[2];
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
  }
  
  // If it's already in YYYY-MM-DD format, return as is
  if (dateString.includes('-')) {
    return dateString;
  }
  
  return '';
};

// Watch for changes in selected days to clear "I don't know yet" when days are selected
watch(() => form.value.selectedDays || [], (newDays: string[]) => {
  if (newDays.length > 0) {
    form.value.scheduleUnknown = false;
  }
}, { deep: true });

// Watch for changes in form values and emit to parent
watch(() => form.value, (newForm: any) => {
  const userDetails = {
    gender: newForm.gender,
    is_ongoing_job: newForm.isOngoingJob,
    days_time: newForm.isOngoingJob === 'yes' ? 
      (newForm.scheduleUnknown ? 'I don\'t know yet' : 
        newForm.selectedDays?.map((day: string) => ({
          [getDayNumber(day)]: 1,
          start_time: (newForm.daySchedules as any)[day]?.startTime || '',
          end_time: (newForm.daySchedules as any)[day]?.endTime || ''
        })) || []) :
      {
        start_date: formatDateToDDMMYYYY(newForm.startDate || ''),
        end_date: formatDateToDDMMYYYY(newForm.endDate || '')
      },
    support_worker_age_range: newForm.age,
  };
  emits('update:userDetails', userDetails);
}, { deep: true });

// Watch for changes in jobDetails prop
watch(() => props.jobDetails, (newJobDetails) => {
  if (newJobDetails && Object.keys(newJobDetails).length > 0) {
    initializeFromJobDetails(newJobDetails);
  }
}, { deep: true });

// Initialize form from job details
async function initializeFromJobDetails(jobData: any): Promise<void> {
  
  // Helper function to convert day number to day name
  const getDayNameFromNumber = (dayNumber: number): string => {
    const dayMap: { [key: number]: string } = {
      1: 'monday',
      2: 'tuesday', 
      3: 'wednesday',
      4: 'thursday',
      5: 'friday',
      6: 'saturday',
      7: 'sunday',
      8: 'toBeAdvisedDaysTimes',
    };
    return dayMap[dayNumber] || '';
  };

  // Helper function to parse ongoing job schedule
  const parseOngoingJobSchedule = (daysTimeData: any[]): { selectedDays: string[], daySchedules: any } => {
    const selectedDays: string[] = [];
    const daySchedules = {
      monday: { startTime: '', endTime: '' },
      tuesday: { startTime: '', endTime: '' },
      wednesday: { startTime: '', endTime: '' },
      thursday: { startTime: '', endTime: '' },
      friday: { startTime: '', endTime: '' },
      saturday: { startTime: '', endTime: '' },
      sunday: { startTime: '', endTime: '' },
    };

    if (Array.isArray(daysTimeData)) {
      daysTimeData.forEach((dayData) => {
        // Find the day number (1-7) from the object keys
        const dayNumber = Object.keys(dayData).find(key => key !== 'start_time' && key !== 'end_time');
        
        if (dayNumber) {
          const dayName = getDayNameFromNumber(parseInt(dayNumber));
          if (dayName) {
            selectedDays.push(dayName);
            daySchedules[dayName as keyof typeof daySchedules] = {
              startTime: dayData.start_time || '',
              endTime: dayData.end_time || ''
            };
          }
        }
      });
    }

    return { selectedDays, daySchedules };
  };

  // Parse ongoing job schedule if is_ongoing_job is true
  let selectedDays: string[] = [];
  let daySchedules = {
    monday: { startTime: '', endTime: '' },
    tuesday: { startTime: '', endTime: '' },
    wednesday: { startTime: '', endTime: '' },
    thursday: { startTime: '', endTime: '' },
    friday: { startTime: '', endTime: '' },
    saturday: { startTime: '', endTime: '' },
    sunday: { startTime: '', endTime: '' },
  };

  if (jobData.is_ongoing_job === true && Array.isArray(jobData.days_time)) {
    const scheduleData = parseOngoingJobSchedule(jobData.days_time);
    selectedDays = scheduleData.selectedDays;
    daySchedules = scheduleData.daySchedules;
  }
  
  // Update form with job details
  form.value = {
    ...form.value,
    gender: jobData.support_worker_gender ? 
      (Array.isArray(jobData.support_worker_gender) ? jobData.support_worker_gender : [jobData.support_worker_gender]) : 
      [],
    isOngoingJob: jobData.is_ongoing_job === true ? 'yes' : 'no',
    selectedDays: selectedDays,
    daySchedules: daySchedules,
    scheduleUnknown: jobData.days_time?.scheduleUnknown || false,
    startDate: parseDate(jobData.days_time?.start_date || ''),
    endDate: parseDate(jobData.days_time?.end_date || ''),
    age: jobData.support_worker_age_range ? 
      (Array.isArray(jobData.support_worker_age_range) ? jobData.support_worker_age_range : [jobData.support_worker_age_range]) : 
      [],
  };

  v$.value.$reset();
  
  // Emit updated userDetails to parent
  const userDetails = {
    gender: form.value.gender,
    is_ongoing_job: form.value.isOngoingJob,
    days_time: form.value.isOngoingJob === 'yes' ? 
    (form.value.scheduleUnknown ? 'I don\'t know yet' : 
    form.value.selectedDays?.map((day: string) => ({
      [getDayNumber(day)]: 1,
      start_time: (form.value.daySchedules as any)[day]?.startTime || '',
      end_time: (form.value.daySchedules as any)[day]?.endTime || ''
    })) || []) :
    {
      start_date: formatDateToDDMMYYYY(form.value.startDate || ''),
      end_date: formatDateToDDMMYYYY(form.value.endDate || '')
    },
    support_worker_age_range: form.value.age,
  };
  emits('update:userDetails', userDetails);
}

async function handleSubmit(): Promise<void> {
  onSubmit(async () => {
    await execSubmit('support-preference', {
      method: 'POST',
      body: {
        ...form.value,
        catered_professional_attributes: selectedAttributes.value.map((i: IAttribute) => i.id),
        restrictions: selectedRestrictions.value.map((i: IRestriction) => i.id),
      },
    });

    if (!serverError.value) {
      user.support_preference = data.value?.data?.support_preference;
      
      // Also save support preference fields directly to user object for easier access
      if (data.value?.data?.support_preference) {
        const pref = data.value.data.support_preference;
        user.support_worker_gender = pref.gender;
        user.is_ongoing_job = pref.isOngoingJob;
        user.selected_days = pref.selectedDays;
        user.day_schedules = pref.daySchedules;
        user.schedule_unknown = pref.scheduleUnknown;
        user.job_start_date = pref.startDate;
        user.job_end_date = pref.endDate;
        user.support_worker_age = pref.age;
      }
      
      props.isOnboarding ? emits('next', 'privacy-policy') : emits('success');
      showSnackbar({ text: 'Support preferences saved.', state: true });
    }
  });
}

function handleGenderChange(genderValue: string, isChecked: boolean) {
  if (genderValue === 'none') {
    // If "no preference" is selected, clear all other selections
    if (isChecked) {
      form.value.gender = ['none'];
    } else {
      // If "no preference" is unchecked, remove it from the array
      form.value.gender = (form.value.gender as string[]).filter(g => g !== 'none');
    }
  } else {
    // If a specific gender is selected, remove "no preference" if it exists
    if (isChecked) {
      form.value.gender = (form.value.gender as string[]).filter(g => g !== 'none');
    }
  }
}

function handleAgeChange(ageValue: string, isChecked: boolean) {
  if (ageValue === 'none' || ageValue === 'I dont mind') {
    // If "none" or "I don't mind" is selected, clear all other selections
    if (isChecked) {
      form.value.age = [ageValue];
    } else {
      // If "none" is unchecked, remove it from the array
      form.value.age = (form.value.age as string[]).filter(a => a !== ageValue);
    }
  } else {
    // If a specific age is selected, remove "none" if it exists
    if (isChecked) {
      form.value.age = (form.value.age as string[]).filter(a => a !== 'none' && a !== 'I dont mind');
    }
  }
}

onMounted(() => {
  nextTick(async () => {
    await Promise.all([debouncedSearchAttributes(), debouncedSearchRestrictions()]);
    await initialize();
    
    // If jobDetails are already available, initialize from them
    if (props.jobDetails && Object.keys(props.jobDetails).length > 0) {
      await initializeFromJobDetails(props.jobDetails);
    }
  });
});
</script>

<style lang="scss" scoped>
.collapsible-section {
  margin-bottom: 2rem;
  background: #fafafa;
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  padding: 1.5rem;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.chevron-btn {
  margin-left: 1rem;
}

.desc {
  font-size: 0.95em;
  color: #555;
}

.support-preferences {
  width: 100%;
  max-width: var(--form-max-width);
}

.card-option-item {
  padding: 0px !important;
}

.error-message {
  font-size: 0.875rem;
  margin-bottom: 0.25rem;
  color: red;
}
.error-message:last-child {
  margin-bottom: 0;
}

// Error styling for Support Worker Gender section
.error-card {
  border: 2px solid #ff5252 !important;
  border-radius: 8px;
  
  :deep(.v-card-title) {
    color: #ff5252 !important;
    font-weight: 600;
  }
}

.error-checkbox {
  :deep(.v-selection-control) {
    .v-selection-control__input {
      .v-selection-control__ripple {
        color: #ff5252 !important;
      }
    }
  }
  
  :deep(.v-selection-control--dirty) {
    .v-selection-control__input {
      .v-selection-control__ripple {
        color: #ff5252 !important;
      }
    }
  }
}

.error-radio {
  :deep(.v-selection-control) {
    .v-selection-control__input {
      .v-selection-control__ripple {
        color: #ff5252 !important;
      }
    }
  }
  
  :deep(.v-selection-control--dirty) {
    .v-selection-control__input {
      .v-selection-control__ripple {
        color: #ff5252 !important;
      }
    }
  }
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  .v-progress-circular {
    margin-bottom: 10px;
  }

  p {
    font-size: 1rem;
    color: #333;
  }
}

.support-preferences.loading-disabled {
  pointer-events: none;
  opacity: 0.7;
}

// Fix for radio item text being cut off - more specific targeting
:deep(.card-option-item) {
  .v-sheet {
    .AppTypography[type="body-1"] {
      line-height: 1.8 !important;
      padding-top: 4px !important;
      padding-bottom: 4px !important;
    }
  }
}

// Alternative approach - target the specific radio items in this form
:deep(.AppFormRadioItem) {
  .v-sheet {
    .AppTypography[type="body-1"] {
      line-height: 1.8 !important;
      padding-top: 4px !important;
      padding-bottom: 4px !important;
    }
  }
}

// Target the specific ongoing job radio items
:deep(.ongoing-job-radio) {
  .v-sheet {
    .AppTypography[type="body-1"] {
      line-height: 1.8 !important;
      padding-top: 4px !important;
      padding-bottom: 4px !important;
    }
  }
}

// More aggressive approach - target any typography within the ongoing job section
:deep(.ongoing-job-radio) {
  * {
    line-height: 1.8 !important;
  }
  
  .AppTypography {
    line-height: 1.8 !important;
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }
  
  // Target the specific description text
  .AppTypography[type="body-1"] {
    line-height: 1.8 !important;
    padding-top: 4px !important;
    padding-bottom: 4px !important;
  }
}

// Last resort - target by the text content
:deep(.ongoing-job-radio) {
  .v-sheet {
    div:has(.AppTypography) {
      .AppTypography {
        line-height: 1.8 !important;
        padding-top: 4px !important;
        padding-bottom: 4px !important;
      }
    }
  }
}
</style>

<style>
/* Force override for ongoing job radio items */
.ongoing-job-radio .v-sheet .AppTypography[type="body-1"] {
  line-height: 1.8 !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

/* Alternative targeting */
.ongoing-job-radio .AppTypography {
  line-height: 1.8 !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

/* Target by component structure */
.ongoing-job-radio .v-sheet div .AppTypography {
  line-height: 1.8 !important;
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}
</style>
